import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormAlert from "./Shared/FormAlert";
import LanguageToggle from "./Shared/LanguageToggle";
import cognitoAuthService from "../../services/cognitoAuthService";
import { LOGO_URL } from "../../constants";
import "../../styles/auth.css";

const ApproveAccount = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [approving, setApproving] = useState(false);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) {
      setError(t('approval.missingToken'));
      setLoading(false);
      return;
    }

    cognitoAuthService
      .getApprovalInfo(token)
      .then((data) => {
        setInfo(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || t('approval.invalidToken'));
        setLoading(false);
      });
  }, [token, t]);

  const handleApprove = async () => {
    try {
      setApproving(true);
      setError("");
      await cognitoAuthService.approveAccount(token);
      setSuccess(
        t('approval.accountApproved', { email: info.email }),
      );
    } catch (err) {
      setError(err.message || t('approval.approvalFailed'));
    } finally {
      setApproving(false);
    }
  };

  return (
    <div className="login-page">
      <div className="brand-header">
        <img src={LOGO_URL} alt="Logo" className="brand-logo" />
      </div>
      <div className="login-card">
        <LanguageToggle />
        <div className="form-container">
          <h3>{t('approval.title')}</h3>

          <FormAlert type="error" message={error} />
          <FormAlert type="success" message={success} />

          {loading && !error && (
            <p className="info-text">{t('approval.loadingDetails')}</p>
          )}

          {info && !success && (
            <>
              <div className="approval-details">
                <div className="approval-detail-row">
                  <span className="approval-label">{t('approval.emailLabel')}</span>
                  <span className="approval-value">{info.email}</span>
                </div>
                <div className="approval-detail-row">
                  <span className="approval-label">{t('approval.organisationLabel')}</span>
                  <span className="approval-value">{info.org_name}</span>
                </div>
              </div>
              {info.already_approved ? (
                <FormAlert
                  type="success"
                  message={t('approval.alreadyApproved')}
                />
              ) : (
                <>
                  <p className="info-text">
                    {t('approval.userRequiresApproval')}
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={handleApprove}
                    disabled={approving}
                  >
                    {approving ? (
                      <span className="spinner"></span>
                    ) : (
                      <span>{t('approval.approveButton')}</span>
                    )}
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApproveAccount;
